// extracted by mini-css-extract-plugin
export default {"thanks":"JoinWaitListThanks_thanks__TB7-+"};